<template>
	<div>
		<el-dialog title="查看交付内容" width="420px" :visible.sync="visible" :before-close="handleClose">
			<div class="tips fz-14 mb-12 flex flex-align-center" v-if="!row.is_auth">
				<i class="iconfont icon-a-info-circle-oxinxi-xian yx-color-primary mt-2"></i>
				<span class="yx-color-text-primary ml-6">未授权达人无法获得短视频链接。</span>
				<!--        获取短视频需要走新授权接口新流程等后面支持了再开放-->
				<!--				<el-popover placement="bottom-end" width="302" trigger="hover">-->
				<!--					<div class="pl-6 pr-6 pt-16 pb-16">-->
				<!--						<div class="fz-12 yx-color-text-primary">-->
				<!--							<p>1、<span class="yx-color-primary pointer" @click="copy(copy_link)">点击此处复制授权链接</span>，达人通过电脑登录达人账号授权</p>-->
				<!--							<p>2、将以下二维码截图发送给达人，通过“{{ platformName }}App”</p>-->
				<!--							<p>扫码授权</p>-->
				<!--						</div>-->
				<!--						<div class="img-loading mt-10">-->
				<!--							<div class="qr-code" v-if="qr_code">-->
				<!--								<img :src="qr_code" alt="" />-->
				<!--							</div>-->
				<!--							<div class="no-qr-code align-center" v-else>-->
				<!--								<img src="@/assets/public/img_loading.png" alt="" />-->
				<!--							</div>-->
				<!--						</div>-->
				<!--						<div class="yx-color-warning fz-12 align-center mt-10"> 授权后将匹配抖音号更新授权状态，请耐心等待 </div>-->
				<!--					</div>-->
				<!--					<span class="yx-color-primary pointer" slot="reference">邀请达人授权</span>-->
				<!--				</el-popover>-->
			</div>
			<div class="user_info_box">
				<user-info-box :row="row" :is_good_type="1"></user-info-box>
				<div :class="['auth', !row.is_auth ? 'warning' : 'success']">
					{{ !row.is_auth ? '未授权' : '已授权' }}
				</div>
				<div :class="['triangle', !row.is_auth ? 'border-warning' : 'border-success']"></div>
			</div>
			<el-tabs>
				<el-tab-pane label="短视频链接">
					<el-button type="primary" @click="showAdd" v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])">添加短视频链接</el-button>
					<div class="emtry" v-if="!effectArr.length">
						<img src="@/assets/public/empty-img.png" alt="" />
						<p class="yx-color-text-secondary">暂无数据</p>
					</div>
					<div class="mt-10 content" v-if="effectArr.length && row.is_auth">
						<div v-for="(item, index) in effectArr" :key="index">
							<div class="flex flex-just-between mb-10 un-item" v-if="item.is_pull === '1'">
								<div class="left">
									<img :src="item.video_cover" alt="" />
								</div>
								<div class="middle flex-column flex-just-between ml-10">
									<div>
										<div class="fz-13 flex flex-just-between yx-color-text-primary">
											<div class="title flex flex-align-center" @click="skipFun(item.share_url)">
												<el-tooltip class="item" effect="dark" :content="item.video_title" placement="top">
													<p>{{ item.video_title }}</p>
												</el-tooltip>
												<i v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])" class="el-icon-arrow-right ml-6 mt-2"></i>
											</div>
											<div class="un-right flex flex-align-center">
												<i class="el-icon-copy-document mr-10 copy-icon pointer" @click="copy(item.share_url)"></i>
												<i class="el-icon-delete pointer delete-icon" @click="showDel(item.video_id, 0)"></i>
											</div>
										</div>
										<div class="time mt-4 yx-color-text-secondary mb-4">
											<p class="fz-12">发布时间 {{ item.pub_time }}</p>
											<p class="fz-12">数据更新时间 {{ item.last_time }}</p>
										</div>
									</div>
									<div class="box flex fz-13">
										<div class="like mr-16">
											<el-tooltip class="item" effect="dark" content="点赞量" placement="bottom">
												<i class="iconfont icon-dianzan dianzan"></i>
											</el-tooltip>
											<span class="ml-4">{{ item.like_num }}</span>
										</div>
										<div class="comment mr-16">
											<el-tooltip class="item" effect="dark" content="评论" placement="bottom">
												<i class="iconfont icon-pinglun pinglun"></i>
											</el-tooltip>
											<span class="ml-4">{{ item.comment_num }}</span>
										</div>
										<!-- <div class="collect mr-16">
                                    <i class="iconfont icon-shoucang shoucang"></i>
                                    <span class="ml-4">{{ item.play_num }}</span>
                                </div> -->
										<div class="forward">
											<el-tooltip class="item" effect="dark" content="转发" placement="bottom">
												<i class="iconfont icon-fenxiang1 fenxiang1"></i>
											</el-tooltip>
											<span class="ml-4">{{ item.share_num }}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="un-item" v-else>
								<div class="flex flex-just-between flex-align-center">
									<div class="un-left skip flex flex-just-between flex-align-center yx-color-text-primary" @click="skipFun(item.share_url)">
										<span>短视频链接：</span>
										<div class="flex flex-align-center">
											<el-tooltip class="item" effect="dark" :content="item.video_url" placement="top">
												<span class="link">{{ item.video_url }}</span>
											</el-tooltip>
											<i v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])" class="el-icon-arrow-right"></i>
										</div>
									</div>
									<div class="un-right flex flex-align-center">
										<i class="el-icon-copy-document mr-10 copy-icon pointer" @click="copy(item.share_url)"></i>
										<i class="el-icon-delete pointer delete-icon" @click="showDel(item.video_id, 1)"></i>
									</div>
								</div>
								<div class="fz-12 yx-color-text-secondary mt-4">
									<span>上传时间</span>
									<span class="ml-6">{{ item.add_time }}</span>
								</div>
								<div :class="['fz-12 mt-6', item.is_pull === '2' ? 'yx-color-danger' : 'yx-color-warning']">
									{{ item.is_pull === '2' ? '同步失败' : '数据同步中…' }}
								</div>
							</div>
						</div>
					</div>
					<div class="unauthorized content mt-20" v-if="effectArr.length && !row.is_auth">
						<div class="un-item mb-20" v-for="(item, index) in effectArr" :key="index">
							<div class="flex flex-just-between flex-align-center">
								<div class="un-left skip flex flex-just-between flex-align-center yx-color-text-primary" @click="skipFun(item.share_url)">
									<span>短视频链接：</span>
									<div class="flex flex-align-center">
										<el-tooltip class="item" effect="dark" :content="item.video_url" placement="top">
											<span class="link">{{ item.video_url }}</span>
										</el-tooltip>
										<i v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])" class="el-icon-arrow-right"></i>
									</div>
								</div>
								<div class="un-right flex flex-align-center">
									<i class="el-icon-copy-document mr-10 copy-icon pointer" @click="copy(item.share_url)"></i>
									<i class="el-icon-delete pointer delete-icon" @click="showDel(item.video_id, 1)"></i>
								</div>
							</div>
							<div class="fz-12 yx-color-text-secondary mt-4">
								<span>上传时间</span>
								<span class="ml-6">{{ item.add_time }}</span>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="带货截图">
					<uploadImg @saveCardLink="saveCardLink" ref="uploadImg" :default_img_list="defaultImg" :limit="99" :multiple="true"></uploadImg>
				</el-tab-pane>
			</el-tabs>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleClose">我知道了</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="deleteVisible" width="420px">
			<div class="flex flex-align-center">
				<img src="@/assets/public/warning-org.png" class="del-img" alt="" />
				<span class="yx-color-text-primary ml-8 bind_text">
					{{ video_status ? '是否确认删除？' : '删除后会重新判断该合作进度的“开始合作时间”，相关带货数据可能发生变化。' }}
				</span>
			</div>
			<p v-if="video_status" class="yx-color-text-primary ml-24 mt-4">删除后将无法找回该链接，只能重新上传。</p>
			<div slot="footer" class="dialog-footer">
				<el-button @click="deleteVisible = false">取 消</el-button>
				<el-button type="primary" @click="delEffectData">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="添加短视频链接" :visible.sync="addVisible" width="420px" @close="resetForms">
			<el-form :model="addFrom" ref="addFrom" :rules="addRuels">
				<el-form-item label="短视频链接：" prop="video_url">
					<el-input type="textarea" :rows="2" placeholder="请输入短视频链接" v-model="addFrom.video_url"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addVisible = false">取 消</el-button>
				<el-button type="primary" @click="addConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import userInfoBox from '@/components/common/userInfoBox';
import uploadImg from '@/components/common/uploadImg';
import { effectList, delEffectData, addEffectData, authorizeUrl, getDeliveryContent, deliveryEdit } from '@/api/cooperationProgress.js';
export default {
	components: {
		userInfoBox,
		uploadImg,
	},
	computed: {
		platformName({ row }) {
			return this.getPlatformName(row.platform_id);
		},
	},
	data() {
		return {
			visible: false,
			deleteVisible: false,
			addVisible: false,
			row: {},
			addFrom: {
				video_url: '',
				video_pic: '',
			},
			addRuels: {
				video_url: [{ required: true, message: '请填写短视频链接', trigger: 'blur' }],
			},
			effectArr: [],
			picList: [],
			video_id: '',
			video_status: 0,
			qr_code: '',
			copy_link: '',
			detail: {},
			defaultImg: [],
		};
	},
	methods: {
		handleClose() {
			console.log(0);
			this.visible = false;
		},
		async saveCardLink(val) {
			console.log(val);
			this.picList = val;
			let params = {
				cooperate_id: this.row.cooperate_id,
				image_list: val,
			};
			await deliveryEdit(params);
		},
		show(row) {
			this.row = row;
			this.video_id = '';
			this.qr_code = '';
			this.copy_link = '';
			this.effectList(row);
			this.getPicList(row);
			this.$refs.uploadImg.setImgs([]);
			if (this.$isPlatOr(row.platform_id, ['Dy', 'Ks'])) {
				this.authorizeUrl(row);
			}
		},
		async getPicList({ cooperate_id }) {
			const { code, data } = await getDeliveryContent({
				cooperate_id,
			});
			if (code !== 0) return;

			this.picList = data?.image_list?.length ? data.image_list.map(val => val.image_url) : [];
			this.defaultImg = data?.image_list?.length ? data.image_list.map(val => val.image_url) : [];

			this.detail = data;
			this.$refs.uploadImg.setImgs(this.defaultImg);
		},
		async effectList({ cooperate_id }) {
			const { code, data } = await effectList({ cooperate_id });
			if (code !== 0) return;
			this.effectArr = data;
			this.visible = true;
		},
		async authorizeUrl({ cooperate_id, anchor_id }) {
			const { code, data } = await authorizeUrl({ cooperate_id, anchor_id });
			if (code !== 0) return;
			this.qr_code = data.qr_code;
			this.copy_link = data.url;
		},
		async delEffectData() {
			const {
				row: { cooperate_id },
				video_id,
			} = this;
			const { code } = await delEffectData({ cooperate_id, video_id });
			if (code !== 0) return;
			this.$message.success('删除成功');
			this.effectList(this.row);
			this.deleteVisible = false;
		},
		showDel(value, video_status) {
			this.video_status = video_status;
			this.video_id = value;
			this.deleteVisible = true;
		},
		showAdd() {
			this.addVisible = true;
		},
		addConfirm() {
			this.$refs['addFrom'].validate(async valid => {
				if (valid) {
					const {
						row: { cooperate_id },
						addFrom: { video_url },
					} = this;
					const { code, data } = await addEffectData({ cooperate_id, video_url });
					if (code !== 0) return;
					this.effectList(this.row);
					this.$message.success('添加成功');
					this.addVisible = false;
				}
			});
		},
		resetForms() {
			this.addFrom = {
				link: '',
			};
			this.$refs['addFrom'].resetFields();
		},
		skipFun(value) {
			if (this.$isPlatOr(this.row.platform_id, ['Dy', 'Ks'])) {
				var a = document.createElement('a');
				a.setAttribute('href', value);
				a.setAttribute('target', '_blank');
				a.setAttribute('id', 'startTelMedicine');
				// 防止反复添加
				if (document.getElementById('startTelMedicine')) {
					document.body.removeChild(document.getElementById('startTelMedicine'));
				}
				document.body.appendChild(a);
				a.click();
			}
		},
		copy(link) {
			var inputTest = document.createElement('textarea');
			inputTest.value = link;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
	},
};
</script>
<style lang="less" scoped>
.tips {
	background: #ebf2fd;
	padding: 12px 16px;
	border: 1px solid @color-primary;
	border-radius: 2px;
}
.left {
	width: 50px;
	height: 70px;
	background: #f5f5f5;
}
.middle {
	flex: 1;
}
.delete-icon:hover {
	color: @color-danger;
}
.dianzan {
	font-size: 13px;
	color: #fb5243;
}
.pinglun {
	font-size: 13px;
	color: #3375e2;
}
.shoucang {
	font-size: 13px;
	color: #fba543;
}
.fenxiang1 {
	font-size: 13px;
	color: #40d24e;
}
.emtry {
	img {
		width: 120px;
		height: 120px;
	}
	display: flex;
	flex-direction: column;
	align-items: center;
}
.content {
	max-height: 200px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: @color-info;
	}
}
.user_info_box {
	position: relative;
}
.auth {
	position: absolute;
	right: 0;
	top: 0;
	width: 75px;
	height: 20px;
	line-height: 20px;
	font-size: 13px;
	text-align: center;
}
.warning {
	background-color: #fef3e7;
	color: @color-warning;
}
.success {
	background-color: #f5fff6;
	color: @color-success;
}
.triangle {
	position: absolute;
	right: 75px;
	top: 0;
	width: 0;
	height: 0;
	border-left: 20px solid transparent;
	border-bottom: 20px solid transparent;
}
.border-warning {
	border-right: 10px solid #fef3e7;
}
.border-success {
	border-right: 10px solid #f5fff6;
}
.un-item {
	padding: 12px;
	background: rgba(250, 143, 20, 0.03);
}
.skip {
	cursor: pointer;
}
.skip:hover {
	color: @color-primary;
}
.copy-icon:hover {
	color: @color-primary;
}
.del-img {
	width: 16px;
	height: 16px;
}
.un-left {
	white-space: nowrap;
}
.link {
	width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
}
.title {
	p {
		width: 220px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
.title:hover {
	color: @color-primary;
	cursor: pointer;
}
.img-loading {
	margin: 0 auto;
	background: rgba(102, 50, 250, 0.03);
	display: flex;
	align-items: center;
	justify-content: center;
	.no-qr-code {
		img {
			width: 48px;
			height: 42px;
		}
	}
}
</style>
